import React from 'react'

import { ReactComponent as DoubleArrow } from '../../../assets/icons/double-arrow.svg'
import { ReactComponent as FbIcon } from '../../../assets/logos/fb-circle-icon.svg'
import { ReactComponent as PartnerBriteLogo } from '../../../assets/logos/partner-brite-logo-light.svg'
import { ReactComponent as GoogleIcon } from '../../../assets/logos/google-icon.svg'
import { ReactComponent as Dv360Icon } from '../../../assets/logos/dv360-icon.svg'
import { ReactComponent as TikTokIcon } from '../../../assets/logos/tt-icon.svg'

import { getSelectedPlatform } from '../../../helpers/handlePlatformSelection'

import {
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  DV_360_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

import useStyles from './style'

function SocialAuthorizeLogos() {
  const classes = useStyles()
  const selectedPlatform = getSelectedPlatform()

  return (
    <div className={classes.logoContainer}>
      <div className={classes.logo}>
        <PartnerBriteLogo />
      </div>
      <div className={classes.logoMiddle}>
        <DoubleArrow />
      </div>
      <div className={classes.socialLogo}>
        {selectedPlatform === FACEBOOK_PLATFORM && <FbIcon />}
        {selectedPlatform === GOOGLE_PLATFORM && <GoogleIcon />}
        {selectedPlatform === DV_360_PLATFORM && <Dv360Icon />}
        {selectedPlatform === TIKTOK_PLATFORM && <TikTokIcon />}
      </div>
    </div>
  )
}

export default SocialAuthorizeLogos
